import { render, staticRenderFns } from "./MaintenanceDetailsView.vue?vue&type=template&id=6224b1b6&scoped=true&"
import script from "./MaintenanceDetailsView.vue?vue&type=script&lang=js&"
export * from "./MaintenanceDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceDetailsView.vue?vue&type=style&index=0&id=6224b1b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6224b1b6",
  null
  
)

export default component.exports